import { useState } from "react";
import { useI18n } from "@/i18n/I18nContext";
import api from "@/lib/api";
import Ornament from "@/components/Ornament";

export default function Contact() {
  const { t } = useI18n();
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const onChange = (k) => (e) => setForm((s) => ({ ...s, [k]: e.target.value }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      await api.post("/contact", form);
      setSent(true);
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } catch (err) {
      setError(err?.response?.data?.detail || "Erreur");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div data-testid="contact-page">
      <section className="relative" style={{ height: "42vh", minHeight: 320 }}>
        <img src="/photos/prieure-leaves.jpg" alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 hero-vignette" />
        <div className="container-prieure relative h-full flex flex-col justify-end pb-12">
          <div className="font-caps text-[0.72rem] text-white/90 mb-4">{t.contact.kicker}</div>
          <h1 className="font-display text-5xl sm:text-7xl text-white">{t.contact.title}</h1>
        </div>
      </section>

      <div className="py-20">
      <div className="container-prieure max-w-4xl">
        <Ornament className="mb-8" />
        <p className="font-display italic text-xl text-center max-w-2xl mx-auto mb-16" style={{ color: "var(--ink-2)" }}>
          {t.contact.intro}
        </p>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-7">
            {sent ? (
              <div data-testid="contact-success" className="illuminated-border bg-white text-center py-16">
                <div className="font-display text-3xl mb-2" style={{ color: "var(--cinnabar)" }}>✦</div>
                <p className="font-display text-2xl">{t.contact.success}</p>
              </div>
            ) : (
              <form onSubmit={onSubmit} data-testid="contact-form" className="space-y-6">
                <div>
                  <label className="label-caps">{t.contact.name}</label>
                  <input data-testid="contact-name" required value={form.name} onChange={onChange("name")}
                         className="input-classic" />
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  <div>
                    <label className="label-caps">{t.contact.email}</label>
                    <input data-testid="contact-email" required type="email" value={form.email}
                           onChange={onChange("email")} className="input-classic" />
                  </div>
                  <div>
                    <label className="label-caps">{t.contact.phone}</label>
                    <input data-testid="contact-phone" type="tel" value={form.phone}
                           onChange={onChange("phone")} className="input-classic" />
                  </div>
                </div>
                <div>
                  <label className="label-caps">{t.contact.subject}</label>
                  <input data-testid="contact-subject" value={form.subject} onChange={onChange("subject")}
                         className="input-classic" />
                </div>
                <div>
                  <label className="label-caps">{t.contact.message}</label>
                  <textarea data-testid="contact-message" required rows={6} value={form.message}
                            onChange={onChange("message")} className="input-classic" style={{ resize: "vertical" }} />
                </div>
                {error && <p className="font-body text-sm" style={{ color: "var(--cinnabar)" }}>{String(error)}</p>}
                <button data-testid="contact-submit" type="submit" disabled={submitting} className="btn btn-primary">
                  {submitting ? t.common.loading : t.contact.send}
                </button>
              </form>
            )}
          </div>

          <div className="md:col-span-5">
            <div className="illuminated-border bg-white">
              <div className="label-caps mb-4" style={{ color: "var(--cinnabar)" }}>{t.contact.direct}</div>
              <div className="space-y-4 font-body">
                <div>
                  <div className="label-caps mb-1">Email</div>
                  <a href="mailto:contact@prieure-saint-leonard.fr" className="link-underline text-lg">
                    contact@prieure-saint-leonard.fr
                  </a>
                </div>
                <div>
                  <div className="label-caps mb-1">{t.contact.phoneLabel}</div>
                  <a href="tel:+33745200900" className="link-underline text-lg">+33 7 45 20 09 00</a>
                </div>
                <div>
                  <div className="label-caps mb-1">{t.contact.addressLabel}</div>
                  <p className="text-lg">Prieuré saint Léonard<br />50300 Vains, France</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
}
